import { Component, EventEmitter, Output, inject } from '@angular/core'; // Added inject
import { CommonModule } from '@angular/common';
// PrimeNG
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog'; // Added DialogService, DynamicDialogRef
// Project specific
import { LessonComponentEnum } from '../../lesson-mini-components/components/lessons.clases';
import { DynamicComponentsBuilderService } from '../../dynamic-components/dynamic-components-builder.service';

@Component({
  selector: 'dc-lesson-component-adder',
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule],
  templateUrl: './dc-lesson-component-adder.component.html',
  styleUrls: ['./dc-lesson-component-adder.component.css'],
  providers: [DialogService], // Provide DialogService here
})
export class DCLessonComponentAdderComponent {
  // Services
  #dynamicComponentsBuilderService = inject(DynamicComponentsBuilderService);

  @Output() componentAdded = new EventEmitter<any>(); // Changed Output name and type

  // Expose enum to the template
  public lessonComponentEnum = LessonComponentEnum;

  // Logic to open component builder, now utilizing DynamicComponentsBuilderService
  public openComponentBuilder(type: string): void {
    const dialogRef: DynamicDialogRef | undefined = this.#dynamicComponentsBuilderService.openComponentBuilder(type);

    if (dialogRef) {
      // Handle the result and emit the new event
      dialogRef.onClose.subscribe((result) => {
        if (result) {
          console.log('Component builder closed:', result);
          this.componentAdded.emit(result); // Emit the result when dialog closes successfully
        }
      });
    } else {
      // Optional: Log if the dialog couldn't be opened, though the service already logs an error.
      console.warn(`Dialog could not be opened for type via component: ${type}`);
    }
  }
}
